<template>
  <div class="d-flex column justify-content-center align-items-center">
    <h1>404</h1>
    <p>We would not find the document you were looking for</p>
  </div>
</template>

<script>
export default {
  name: "NotFound"
};
</script>

<style scoped>
.column {
  flex-direction: column !important;
  text-align: center;
}
</style>
